<ng-container *ngIf="layers$ | async as layers">
  <div *ngFor="let layer of layers" [ngStyle]="layer"></div>
</ng-container>
